export default __webpack_public_path__ + "77ca268ad632363436384ebad45498e3.svg";